module.exports = __webpack_public_path__ + "img/woman-smartphone.a9e41c2b.jpg";